<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Declaración de los Trabajadores</h3>
      </div>
    </div>
  </div>
  <hr class="text-dark">

  <h3 class="text-center">Cuota Anual</h3>


  <form [formGroup]="formularioRegistro" id="formularioReprogrma">

    <!-- Invoice Logo-->
    <div class="row">
      <label for="ano" class="col-form-label text-center">Año</label>
      <div class="col-md-12">
        <select class="form-select shadow-lg form-select-lg" id="ano" name="ano" formControlName="anio" (change)="onChangeYear($event)">
          <option *ngFor="let op of years" [value]="op" [selected]="op == selectedYear ? true : false">
            {{op}}
          </option>
        </select>
      </div>
    </div>

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">
            <div class="row mt-3">
              <div class="col-12">Rif: <span style="color: #016E97;">{{rif}}</span></div>
            </div>
            <div class="row" style="margin-top: -10px;">
              <div class="col-12">Razón Social: <span style="color: #016E97;">{{nombre_empresa}}</span></div>
            </div>
          </h4>
        </div>
      </div>
    </div>

    <!-- Caloculo ppr meses -->
    <div class="row mt-3" id="calculo">
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Enero</label>
        <input type='text' id='enero' class='form-control shadow-lg' formControlName="enero" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Febrero</label>
        <input type='text' id='febrero' class='form-control shadow-lg' formControlName="febrero" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Marzo</label>
        <input type='text' id='marzo' class='form-control shadow-lg' formControlName="marzo" mask="99" (input)="evluar()">
      </div>

      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Abril</label>
        <input type='text' id='abril' class='form-control shadow-lg' formControlName="abril" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Mayo</label>
        <input type='text' id='mayo' class='form-control shadow-lg' formControlName="mayo" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Junio</label>
        <input type='text' id='junio' class='form-control shadow-lg' formControlName="junio" mask="99" (input)="evluar()">
      </div>

      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Julio</label>
        <input type='text' id='julio' class='form-control shadow-lg' formControlName="julio" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Agosto</label>
        <input type='text' id='agosto' class='form-control shadow-lg' formControlName="agosto" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Septiembre</label>
        <input type='text' id='septiembre' class='form-control shadow-lg' formControlName="septiembre" mask="99" (input)="evluar()">
      </div>

      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Octubre</label>
        <input type='text' id='octubre' class='form-control shadow-lg' formControlName="octubre" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Noviembre</label>
        <input type='text' id='noviembre' class='form-control shadow-lg' formControlName="noviembre" mask="99" (input)="evluar()">
      </div>
      <div class="col-md-4 mb-3 text-center">
        <label class='form-label'>Diciembre</label>
        <input type='text' id='diciembre' class='form-control shadow-lg' formControlName="diciembre" mask="99" (input)="evluar()">
      </div>
    </div>

    <!-- Evaluacion -->
    <div class="row mb-5 mt-3">
      <div class="col-md-6">
        <label class='form-label'>Promedio Anual de Trabajadores es igual a la sumatoria de los meses del año dividido entre doce (12)</label>
        <input type='text' id='division' class='text-end fw-bold form-control form-control-lg shadow-lg' formControlName="promedio" style="background-color: #A7DAED;" readonly>
      </div>
      <div class="col-md-6">
        <label class='form-label'>La Cuota de Obligación civil la determina el INCES y se encuentra entre el tres(3%) y cinco (5%)</label>
        <input type='text' id='porcentaje' class='text-end fw-bold form-control form-control-lg shadow-lg' formControlName="cuota" style="background-color: #A7DAED;" readonly>
      </div>
    </div>

  </form>
  <!-- start page title
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <h3 class="page-title">Declaración de Aprendices: <a class="btn btn-primary" (click)="aspirantes(content)"><i class="bi bi-search"></i> Buscar Aspirante</a></h3>
      </div>
    </div>
  </div>
  <hr class="text-dark">

  <div class="row">
    <div class="col-md-12">
      <div class="card  shadow-lg">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->

  <hr class="text-dark">
  <div class="col-12 text-center">
    <button type="button" class="btn btn-lg btn-primary" (click)="guardar()">{{textoBoton}}</button>
  </div>


  <div style="margin-bottom: 200px;"></div>
</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>


<ng-template #content let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Selecion de Aspirantes</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<div class="row">
      <div class="col-md-12">
        <label for="estadol" class="col-form-label">Estado</label>
        <!-- start page title
        <select class="form-select" id="estado" name="estado" (change)="consulta_combos($event.target)">
          <option value="" selected>--SELECCIONES--</option>
          <option *ngFor="let ed of arrEstado" [value]="ed.id_estado">{{ed.nombre}}</option>
        </select>
        -->
      </div>
    </div>
    <hr class="text-dark">
    <!--ng-container *ngIf="valor">
      <div class="row">
        <div class="col-md-12">
          <input
            class="form-control"
            type="text"
            id="buscar"
            placeholder="Buscar..."
            [(ngModel)]="searchTerm"
            (input)="buscar()"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="margin-top: 10px;" *ngFor="let est of filteredResultado; let i=index;">
          <div class="form-check" style="padding-left: 2.5rem;">
            <input class="form-check-input"
                  type="checkbox"
                  id="estudiante_{{est.id_estudiante}}"
                  value="{{est.id_estudiante}}"
                  id="estudiante_{{est.id_estudiante}}"
                  style="font-size: 20px; border: 3px solid #313131;"
                  [(ngModel)]="est.seleccionado"
                  (change)="seleccionarAspirante(est)">
            <label class="form-check-label" for="estudiante_{{est.id_estudiante}}">{{est.identificacion}} - {{est.nombre_full}}</label>
          </div>
        </div>
      </div>
    </ng-container-->
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Cerrar</button>
		<button type="button" class="btn btn-primary">Aceptar</button>
	</div>
</ng-template>


